import { atomWithStorage } from 'jotai/utils';

export const stepsCountAtom = atomWithStorage<number | undefined>(
  'onboarding-steps-count',
  undefined,
);
